// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hive_t1fa7to6{margin-bottom:20px;min-height:44px;}\n.hive_i1skf7lq{font-family:Menlo,sans-serif !important;font-size:14px !important;}\n.hive_csthg0n{color:var(--success-primary);}\n", ""]);
// Exports
module.exports = exports;
